import { render, staticRenderFns } from "./CatalogSidebar.vue?vue&type=template&id=1c86bf02&scoped=true"
import script from "./CatalogSidebar.vue?vue&type=script&lang=js"
export * from "./CatalogSidebar.vue?vue&type=script&lang=js"
import style0 from "./CatalogSidebar.vue?vue&type=style&index=0&id=1c86bf02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86bf02",
  null
  
)

export default component.exports